///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export abstract class ActiveRestorableWindow {
    abstract isRestorable(): boolean;

    abstract designRequired(): boolean;
}
